export const isInAgeGroup = (student, desiredGroup) => {
  if (desiredGroup === 'all') return true
  if (student.isMinor && desiredGroup === 'junior') return true
  if (!student.isMinor && desiredGroup === 'adult') return true
  return false
}

export const matchesSearchTerm = (student, term) => {
  const normalizedTerm = term.toLowerCase().trim()
  if (!normalizedTerm) return true

  const searchableFields = [
    student.firstName,
    student.lastName,
    student.contact?.email,
    student.contact?.phone,
  ]

  return searchableFields.some(field =>
    field?.toLowerCase().includes(normalizedTerm),
  )
}
